import flowRight from 'lodash/flowRight';
import { ComponentType } from 'react';

/**
 * Combine multiple component enhancers into a new enhancer that applies all of those given
 *
 * @param enhancers One or more component enhancers
 * @returns A new enhancer that combines those given
 */
const enhance =
  <E extends ((c: ComponentType) => ComponentType)[]>(...enhancers: E) =>
  <P extends {}>(component: ComponentType<P>): ComponentType<P> =>
    flowRight(enhancers)(component);

export default enhance;
